export const L_STORAGE_THEME = "theme";

export const L_SESSION_TOKEN = "tableau_session_token";

export const L_JWT_TOKEN = "jwt_token";

export const L_USER_ID = "user_id";

export const L_SAVED_FILTER = "selected_filter";
